import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { VerticalNavbarLink } from '@knockrentals/knock-react';
import { useAppContext } from '../../Context/AppContext';

const ProtectedNavBarLink = ({ accessSetting, children, path }) => {
  const { isAuthorized } = useAppContext();

  return isAuthorized(accessSetting) ? (
    <NavLink to={path}>
      <VerticalNavbarLink>{children}</VerticalNavbarLink>
    </NavLink>
  ) : null;
};

ProtectedNavBarLink.propTypes = {
  accessSetting: PropTypes.string,
  children: PropTypes.node,
  path: PropTypes.string,
};

export default ProtectedNavBarLink;
